/**
 * Pull the API's real error message out of an axios error. The error body is
 * { success:false, error:{ code, message } }; on 4xx/5xx the api interceptor
 * passes the raw axios error through, whose `.message` is only the useless
 * "Request failed with status code N". Prefer the server's message so toasts
 * explain *why* (e.g. "a DHCP server requires a Bridged LAN interface").
 */
export const apiErrorMessage = (err: any, fallback: string): string =>
  err?.response?.data?.error?.message ||
  err?.response?.data?.message ||
  err?.message ||
  fallback;
